import styled from '../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';
import { ResetButton } from '../bottom-sheet.styles.js';
import { Heading } from '../../typography/heading/heading.js';

var style = getPresets(preset, {});
var MAIN_HEIGHT = '56px';
var PrefixBox = /*#__PURE__*/styled(ResetButton)({
  name: "PrefixBox",
  class: "psy8oti",
  vars: {
    "psy8oti-1": [style.iconColor]
  }
});
var PostfixBox = /*#__PURE__*/styled(ResetButton)({
  name: "PostfixBox",
  class: "pbe1jkq",
  vars: {
    "pbe1jkq-1": [style.iconColor]
  }
});
var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bi54g6f",
  vars: {
    "bi54g6f-0": [function () {
      return MAIN_HEIGHT;
    }],
    "bi54g6f-2": [function (_ref) {
      var dir = _ref.dir;
      return dir === 'rtl' ? 'auto' : 0;
    }],
    "bi54g6f-3": [function (_ref2) {
      var dir = _ref2.dir;
      return dir === 'rtl' ? 0 : 'auto';
    }]
  }
});
var Title = /*#__PURE__*/styled(Heading)({
  name: "Title",
  class: "t1naxa2p",
  vars: {
    "t1naxa2p-0": [function () {
      return MAIN_HEIGHT;
    }]
  }
});
var RoundBox = /*#__PURE__*/styled("div")({
  name: "RoundBox",
  class: "r16rtgxq",
  vars: {
    "r16rtgxq-0": [style.roundBackground],
    "r16rtgxq-1": [style.iconColor]
  }
});

export { Box, PostfixBox, PrefixBox, RoundBox, Title };


require('../../../styles-linaria/bottom-sheet/bottom-sheet-header/bottom-sheet-header.styles.css');
